/*
 * TTG Rassesuche (Briefing rassesuche-synonyme, 03.11.2026). Ein Skript für die Startseite (sections/ttg-rudel.liquid)
 * und die A–Z-Seite (sections/ttg-rassesuche.liquid). Daten aus snippets/ttg-rassen-daten.liquid (JSON).
 *
 * Suche: Treffer nur am Wortanfang von Name oder Synonym. Rang: Eingabe = Name/Synonym → Name beginnt → Synonym beginnt
 * → ein Wort im Namen beginnt → ein Wort im Synonym beginnt; bei Gleichstand alphabetisch. Höchstens 8 Vorschläge.
 * Gruppen: passt die Eingabe zu einem Gruppen-Suchwort und beginnt kein Name/Synonym mit ihr, zeigt die Liste die Gruppe.
 * Ereignisse: ttg_rasse_suche (Auswahl, wie bisher) und ttg_rasse_suche_leer (1,5 s nach dem letzten Tastendruck ohne Treffer).
 *
 * Markup je Suche: [data-ttg-rassesuche][data-quelle=<id des JSON>][data-az=<URL A–Z-Seite>][data-bilder]
 *   mit input[role=combobox], ul[role=listbox], [data-ttg-leer].
 * A–Z-Filter: [data-ttg-gruppe]-Knöpfe, Einträge [data-ttg-gr], Buchstaben-Abschnitte [data-ttg-buchstabe],
 *   Buchstabenleiste a[data-ttg-zu]. ?gruppe=<schlüssel> in der URL setzt den Filter beim Laden.
 */
(function () {
  'use strict';

  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function wortAnfang(text, q) { return (' ' + text).indexOf(' ' + q) >= 0; }

  var cache = {};
  function laden(id) {
    if (cache[id]) return cache[id];
    var el = document.getElementById(id);
    if (!el) return null;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    d.r.forEach(function (r) { r.nn = norm(r.n); r.ns = r.s.map(norm); });
    d.g.forEach(function (g) { g.na = g.a.map(norm); });
    cache[id] = d;
    return d;
  }

  function vergleich(a, b) { return a.n.localeCompare(b.n, 'de'); }

  function suchen(d, eingabe) {
    var q = norm(eingabe);
    if (q.length < 2) return { art: 'kurz', treffer: [] };
    var t = [];
    d.r.forEach(function (r) {
      var rang = -1, syn = null, i;
      if (r.nn === q) rang = 0;
      for (i = 0; rang < 0 && i < r.ns.length; i++) if (r.ns[i] === q) { rang = 0; syn = r.s[i]; }
      if (rang < 0 && r.nn.indexOf(q) === 0) rang = 1;
      for (i = 0; rang < 0 && i < r.ns.length; i++) if (r.ns[i].indexOf(q) === 0) { rang = 2; syn = r.s[i]; }
      if (rang < 0 && wortAnfang(r.nn, q)) rang = 3;
      for (i = 0; rang < 0 && i < r.ns.length; i++) if (wortAnfang(r.ns[i], q)) { rang = 4; syn = r.s[i]; }
      if (rang >= 0) t.push({ r: r, rang: rang, syn: syn });
    });
    t.sort(function (a, b) { return a.rang - b.rang || vergleich(a.r, b.r); });
    var stark = t.some(function (x) { return x.rang <= 2; });
    if (q.length >= 3 && !stark) {
      var g = null;
      d.g.forEach(function (gr) {
        if (!g && gr.na.some(function (a) { return a.indexOf(q) === 0 || q.indexOf(a) === 0; })) g = gr;
      });
      if (g) {
        var m = d.r.filter(function (r) { return r.g.indexOf(g.k) >= 0; }).sort(vergleich);
        if (m.length) return { art: 'gruppe', gruppe: g, anzahl: m.length, treffer: m.map(function (r) { return { r: r, rang: 5, syn: null }; }) };
      }
    }
    return { art: t.length ? 'treffer' : 'nichts', treffer: t };
  }

  // Passenden Teil fett: kürzester Ausschnitt ab einem Wortanfang, dessen Normalform der Eingabe entspricht.
  function hervorheben(text, eingabe, ziel) {
    var q = norm(eingabe), i, j;
    for (i = 0; i < text.length; i++) {
      if (i > 0 && /[0-9A-Za-zÀ-ž]/.test(text[i - 1])) continue;
      for (j = i + 1; j <= text.length; j++) {
        var n = norm(text.slice(i, j));
        if (n === q) {
          ziel.appendChild(document.createTextNode(text.slice(0, i)));
          var b = document.createElement('strong'); b.textContent = text.slice(i, j); ziel.appendChild(b);
          ziel.appendChild(document.createTextNode(text.slice(j)));
          return;
        }
        if (n.length > q.length + 2) break;
      }
    }
    ziel.appendChild(document.createTextNode(text));
  }

  function melden(name, daten) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, daten); } catch (e) {}
  }

  var filterSetzen = null;

  function suche(wurzel) {
    var d = laden(wurzel.getAttribute('data-quelle'));
    var eingabe = wurzel.querySelector('[role="combobox"]');
    var liste = wurzel.querySelector('[role="listbox"]');
    var leer = wurzel.querySelector('[data-ttg-leer]');
    if (!d || !eingabe || !liste) return;
    var az = wurzel.getAttribute('data-az') || '/pages/rassesuche';
    var bilder = wurzel.hasAttribute('data-bilder');
    var aktuell = [], aktiv = -1, uhr = null, zuletztLeer = '';

    function option(i, klasse) {
      var li = document.createElement('li');
      li.id = liste.id + '-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.className = klasse;
      return li;
    }

    function zeigen(erg) {
      liste.innerHTML = '';
      aktiv = -1;
      aktuell = [];
      var max = erg.art === 'gruppe' ? 7 : 8;
      erg.treffer.slice(0, max).forEach(function (x, i) {
        var li = option(i, 'ttg-rs-vorschlag');
        if (bilder && x.r.b) {
          var img = document.createElement('img');
          img.src = x.r.b; img.alt = ''; img.width = 48; img.height = 48; img.className = 'ttg-rs-vorschlag__bild';
          li.appendChild(img);
        }
        var txt = document.createElement('span'); txt.className = 'ttg-rs-vorschlag__text';
        var name = document.createElement('span'); name.className = 'ttg-rs-vorschlag__name';
        if (x.rang <= 1 || x.rang === 3) hervorheben(x.r.n, eingabe.value, name); else name.textContent = x.r.n;
        txt.appendChild(name);
        if (x.syn) {
          var auch = document.createElement('span'); auch.className = 'ttg-rs-vorschlag__auch';
          auch.appendChild(document.createTextNode(' · auch: '));
          var s = document.createElement('span'); hervorheben(x.syn, eingabe.value, s); auch.appendChild(s);
          txt.appendChild(auch);
        }
        li.appendChild(txt);
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); waehlen(i); });
        liste.appendChild(li);
        aktuell.push({ typ: 'rasse', r: x.r });
      });
      if (erg.art === 'gruppe') {
        var i = aktuell.length;
        var li = option(i, 'ttg-rs-vorschlag ttg-rs-vorschlag--gruppe');
        li.textContent = 'Alle ' + erg.anzahl + ' Rassen: ' + erg.gruppe.n + ' →';
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); waehlen(i); });
        liste.appendChild(li);
        aktuell.push({ typ: 'gruppe', g: erg.gruppe });
      }
      var offen = aktuell.length > 0;
      liste.hidden = !offen;
      eingabe.setAttribute('aria-expanded', offen ? 'true' : 'false');
      eingabe.removeAttribute('aria-activedescendant');
      if (leer) leer.hidden = erg.art !== 'nichts';
      clearTimeout(uhr);
      if (erg.art === 'nichts') {
        var wert = eingabe.value.trim();
        uhr = setTimeout(function () {
          if (wert && wert !== zuletztLeer) { zuletztLeer = wert; melden('ttg_rasse_suche_leer', { eingabe: wert }); }
        }, 1500);
      }
    }

    function markieren(i) {
      var el = liste.children;
      for (var j = 0; j < el.length; j++) el[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
      aktiv = i;
      if (i >= 0 && el[i]) eingabe.setAttribute('aria-activedescendant', el[i].id);
    }

    function schliessen() {
      liste.hidden = true;
      eingabe.setAttribute('aria-expanded', 'false');
      eingabe.removeAttribute('aria-activedescendant');
    }

    function waehlen(i) {
      var a = aktuell[i];
      if (!a) return;
      if (a.typ === 'rasse') { melden('ttg_rasse_suche', { rasse: a.r.n }); window.location.href = a.r.u; return; }
      if (filterSetzen) { schliessen(); filterSetzen(a.g.k, true); return; }
      window.location.href = az + (az.indexOf('?') >= 0 ? '&' : '?') + 'gruppe=' + encodeURIComponent(a.g.k) + '#rassen';
    }

    eingabe.addEventListener('input', function () { zeigen(suchen(d, eingabe.value)); });
    eingabe.addEventListener('focus', function () { if (norm(eingabe.value).length >= 2) zeigen(suchen(d, eingabe.value)); });
    eingabe.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' && aktuell.length) { ev.preventDefault(); markieren(Math.min(aktiv + 1, aktuell.length - 1)); }
      else if (ev.key === 'ArrowUp' && aktuell.length) { ev.preventDefault(); markieren(Math.max(aktiv - 1, 0)); }
      else if (ev.key === 'Escape') { schliessen(); }
      else if (ev.key === 'Enter') {
        ev.preventDefault();
        var erg = suchen(d, eingabe.value);
        if (aktiv >= 0 && aktuell[aktiv]) waehlen(aktiv);
        else if (erg.art === 'treffer' && erg.treffer.length === 1) { zeigen(erg); waehlen(0); }
        else zeigen(erg);
      }
    });
    eingabe.addEventListener('blur', function () { setTimeout(schliessen, 150); });
  }

  function filter(wurzel) {
    var knoepfe = wurzel.querySelectorAll('[data-ttg-gruppe]');
    if (!knoepfe.length) return;
    var eintraege = wurzel.querySelectorAll('[data-ttg-gr]');
    var abschnitte = wurzel.querySelectorAll('[data-ttg-buchstabe]');
    var leiste = wurzel.querySelectorAll('[data-ttg-zu]');
    var anzeige = wurzel.querySelector('[data-ttg-filter-anzeige]');
    filterSetzen = function (k, scrollen) {
      knoepfe.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ttg-gruppe') === k ? 'true' : 'false'); });
      var n = 0;
      eintraege.forEach(function (e) {
        var an = !k || (' ' + e.getAttribute('data-ttg-gr') + ' ').indexOf(' ' + k + ' ') >= 0;
        e.hidden = !an; if (an) n++;
      });
      var mit = {};
      abschnitte.forEach(function (a) {
        var sichtbar = a.querySelector('[data-ttg-gr]:not([hidden])') !== null;
        a.hidden = !sichtbar; if (sichtbar) mit[a.getAttribute('data-ttg-buchstabe')] = true;
      });
      leiste.forEach(function (l) {
        var an = !!mit[l.getAttribute('data-ttg-zu')];
        l.classList.toggle('is-aus', !an);
        if (an) l.removeAttribute('aria-disabled'); else l.setAttribute('aria-disabled', 'true');
        l.tabIndex = an ? 0 : -1;
      });
      if (anzeige) anzeige.textContent = k ? n + ' Rassen' : '';
      if (scrollen) { var z = document.getElementById('rassen'); if (z) z.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    };
    knoepfe.forEach(function (b) {
      b.addEventListener('click', function () { filterSetzen(b.getAttribute('data-ttg-gruppe'), false); });
    });
    leiste.forEach(function (l) {
      l.addEventListener('click', function (ev) { if (l.getAttribute('aria-disabled') === 'true') ev.preventDefault(); });
    });
    var m = /[?&]gruppe=([a-z-]+)/.exec(window.location.search);
    if (m) filterSetzen(m[1], false);
  }

  function start() {
    document.querySelectorAll('[data-ttg-rs-filter]').forEach(filter);
    document.querySelectorAll('[data-ttg-rassesuche]').forEach(suche);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.ttgRassesuche = { norm: norm, suchen: suchen, laden: laden };
})();
